import React from 'react';

/**
 * Faint plot grid for dark sections — the texture of a monitoring chart,
 * drawn as hairlines rather than decorative shapes.
 */
export function GridBackdrop({
  opacity = 0.5
}: {
  opacity?: number;
}) {
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" style={{
    opacity
  }} data-id="element-339" data-mp="17mc0cepxqsz6">
      <svg className="h-full w-full" width="100%" height="100%" data-id="element-340" data-mp="12shdx3iy3zwe">
        <defs data-id="element-341" data-mp="1hi6plsonzmax">
          <pattern id="plot-grid" width="56" height="56" patternUnits="userSpaceOnUse" data-id="element-342" data-mp="1hhn8ge6u91xy">
            <path d="M 56 0 L 0 0 0 56" fill="none" stroke="#7fe0ab" strokeOpacity="0.12" strokeWidth="1" data-id="element-343" data-mp="1qkodscnvqp0k" />
          </pattern>
          <pattern id="plot-grid-fine" width="14" height="14" patternUnits="userSpaceOnUse" data-id="element-344" data-mp="3sarfxz81v0jn">
            <circle cx="1" cy="1" r="0.5" fill="#7fe0ab" fillOpacity="0.14" data-id="element-345" data-mp="3oc0tqn54h3bb" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#plot-grid-fine)" data-id="element-346" data-mp="2qqsctzrmhx3g" />
        <rect width="100%" height="100%" fill="url(#plot-grid)" data-id="element-347" data-mp="2vs9evylufplm" />
      </svg>
    </div>;
}